import type { FormTourConfig } from './formTour';

const CREATE_SEQUENCE_START_PATH = '/sequences';
const SEQUENCES_PATH_PREFIX = '/sequences';

export const createSequenceTour = {
  taskId: 'create_sequence',
  storageKey: 'onboarding-create-sequence-tour-step',
  startPath: CREATE_SEQUENCE_START_PATH,
  activePathPrefix: SEQUENCES_PATH_PREFIX,
  navStepCount: 1,
  overlineLabel: 'Create Sequence Tour',
  steps: [
    {
      title: 'Open Sequences',
      description: 'Click Sequences in the sidebar to manage outreach sequences.',
      targetTestIds: ['@sidebar-sequences'],
    },
    {
      title: 'Open Add Sequence menu',
      description: 'Add Sequence is a dropdown. Click the Add Sequence button to open the menu.',
      targetTestIds: ['@sequences-add'],
      disableBack: true,
    },
    {
      title: 'Create manually',
      description: 'In the menu, click "Create Manually" to start a new blank sequence.',
      targetTestIds: ['@sequences-create-manually'],
    },
    {
      title: 'Name your sequence',
      description:
        'Click the edit icon next to the title, enter a name, then click outside the field to save. Then click Next to continue.',
      targetTestIds: ['@sequence-name-edit', '@sequence-name-edit-input'],
      disableBack: true,
    },
    {
      title: 'Add a step',
      description: 'On the Steps tab, click Add Step to start your first sequence email.',
      targetTestIds: ['@sequence-add-step'],
      closeTargetTestIdsOnBack: ['@sequence-step-form'],
    },
    {
      title: 'Save the step',
      description: 'Enter a subject and body, then click Save Step. The tour continues when the editor closes.',
      targetTestIds: ['@sequence-step-save'],
      highlightTargetTestIds: ['@sequence-step-save'],
      contextTargetTestIds: ['@sequence-step-form'],
      panelPlacement: 'above',
      closeTargetTestIdsOnBack: ['@sequence-step-form'],
    },
    {
      title: 'Open Settings',
      description: 'Open the Settings tab to choose a Sender Account.',
      targetTestIds: ['@sequence-tab-settings'],
    },
    {
      title: 'Select Sender Account',
      description: 'Choose a Sender Account for this sequence. The guide finishes when an account is selected.',
      targetTestIds: ['@sequence-sender-accounts', '@sequence-sender-account-selected'],
      panelPlacement: 'above',
    },
  ],
  stepActions: {
    0: {
      type: 'wait-for-target',
      advanceTo: 1,
      waitForTargetTestIds: ['@sequences-add'],
    },
    1: {
      type: 'wait-for-target',
      advanceTo: 2,
      waitForTargetTestIds: ['@sequences-create-manually'],
    },
    2: {
      type: 'wait-for-target',
      advanceTo: 3,
      waitForTargetTestIds: ['@sequence-name-edit'],
    },
    3: { type: 'next' },
    4: {
      type: 'wait-for-target',
      advanceTo: 5,
      waitForTargetTestIds: ['@sequence-step-form'],
    },
    5: {
      type: 'wait-for-target-absent',
      advanceTo: 6,
      waitForAbsentTestIds: ['@sequence-step-form'],
    },
    6: {
      type: 'wait-for-target',
      advanceTo: 7,
      waitForTargetTestIds: ['@sequence-settings-panel'],
    },
    7: {
      type: 'complete-when-target',
      waitForTargetTestIds: ['@sequence-sender-account-selected'],
    },
  },
} as const satisfies FormTourConfig;
